import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { FirebaseServiceProvider } from '../providers/firebase-service';

@Injectable({
  providedIn: 'root'
})
export class CrudService {

  public firestore: AngularFirestore = this.fbService.dbGlobal;

  constructor(private fbService: FirebaseServiceProvider) {
  }
  getCollection(entidade: string): AngularFirestoreCollection<any> {
    return this.firestore.collection(entidade);
  }

  listar(entidade: string, campo: string, value: any): Observable<any> {
    return this.firestore.collection<any>(entidade, ref => {
      let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;

      if (campo && value) { query = query.where(campo, '==', value) };

      return query;
    }).valueChanges();
  }

  listarByFiltro(entidade: string, filtro: any[]): Observable<any> {
    return this.firestore.collection<any>(entidade, ref => {
      let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;

      if(filtro){
        for(let f of filtro){
          if (f.campo && f.operacao && f.value) { query = query.where(f.campo, f.operacao, f.value) };
        }
      }
    
      return query;
    }).valueChanges();
  }

  findByGeneric(entidade: string, campo: string, value: any): Observable<any> {
    return this.firestore.collection<any>(entidade, ref => {
      let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;

      if (value) { query = query.where(campo, '==', value) };

      return query;
    }).valueChanges(); 
  }

  salvar(entidade: string, objeto: any) {

    this.getCollection(entidade).doc<any>(objeto.id.toString()).set(Object.assign({}, objeto));
    return objeto.id;
  }

  atualizar(entidade: string, objeto: any) {
    let id: string = objeto.id;
    this.getCollection(entidade).doc<any>(id).set(Object.assign({}, objeto));
  }

  excluir(entidade: string, id: string) {
    this.getCollection(entidade).doc<any>(id).delete();
  }
}
